import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { apiV2 } from "api/firebase";
import { CommonNotificationType } from "@evennt-tech/api-v2-core";

const TRANSLATIONS_QUERY_PREFIX = "productColorTranslations";

const translationsQueryKey = (itemId: string) =>
  [TRANSLATIONS_QUERY_PREFIX, itemId] as const;

export const useProductColorLocalizationState = (itemId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: translationsQueryKey(itemId),
    queryFn: () =>
      apiV2.customProductOption.definition.admin.getTranslationsByItem({
        itemId,
      }),
    enabled: !!itemId,
  });
  return { translations: data ?? [], isLoading };
};

export const useProductColorLocalizationActions = () => {
  const queryClient = useQueryClient();

  const autoCatchTranslations = useCallback(() => {
    apiV2.notification.subscribe({
      key: CommonNotificationType.UPDATE_PRODUCT_COLOR_TRANSLATIONS,
      callback: () =>
        queryClient.invalidateQueries({
          queryKey: [TRANSLATIONS_QUERY_PREFIX],
          predicate: (query) => !!query.queryKey[1],
          refetchType: "all",
        }),
    });

    return () => {
      apiV2.notification.unsubscribe({
        key: CommonNotificationType.UPDATE_PRODUCT_COLOR_TRANSLATIONS,
      });
    };
  }, [queryClient]);

  return { autoCatchTranslations };
};
